module.exports = __webpack_public_path__ + "img/alaska_bears.3f729417.jpg";